export default function Game_Controllers() {
  return (
    <div>
      <h1>Game_Controllers Component</h1>
    </div>
  );
}
